import { render, staticRenderFns } from "./elec-echart.vue?vue&type=template&id=48f7b065&"
import script from "./elec-echart.vue?vue&type=script&lang=ts&"
export * from "./elec-echart.vue?vue&type=script&lang=ts&"
import style0 from "./elec-echart.vue?vue&type=style&index=0&id=48f7b065&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports